import { Action, ActionReducer } from '@ngrx/store';
import {
    deleteWorkspace,
    updateChangeRequest,
    updateCurrentDB,
    updateSidebarVisible,
    updateSopDate,
    updateWorkspace,
} from '../actions/config.action';
import { SesammStorage } from 'src/utils/sesamm-storage';
import { initialState as initialConfigState } from './config.reducer';

export function storageMetaReducer<S, A extends Action = Action>(reducer: ActionReducer<S, A>) {
    let onInit = true;

    return function (state: S, action: A): S {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const nextState: any = reducer(state, action);

        // init the application state.
        if (onInit) {
            onInit = false;
            const savedConfigState = SesammStorage.getConfigStorage();

            return {
                ...nextState,
                ...{
                    config: {
                        ...initialConfigState,
                        ...savedConfigState,
                    },
                },
            };
        }

        // Config state Actions
        else if (
            action.type == updateSopDate.type ||
            action.type == updateWorkspace.type ||
            action.type == deleteWorkspace.type ||
            action.type == updateChangeRequest.type ||
            action.type == updateSidebarVisible.type ||
            action.type == updateCurrentDB.type
        ) {
            const { config } = nextState;
            const stateToSave = {
                ...SesammStorage.getConfigStorage(),
                ...config,
            };
            SesammStorage.setConfigStorage(stateToSave);
        }

        return nextState;
    };
}
